<template>
  <modal v-if="createAccount" @close="createAccount = false" force class="create-account">
    <div slot="body">
      <div>
        <h3>{{ $t('payment.customer.password_title') }}</h3>
        <form @submit.prevent="createPassword">
          <div class="input-group mt-4">
            <div class="col-12 field-col">
              <input-base
                v-model="password"
                type="password" 
                label="payment.customer.create_password"
                id="password"
                :invalid="$v.password.$error"
                @change="$v.password.$touch()"
              />
              <span class="error">{{ validationMsg($v.password) }}</span>
            </div>
            <div class="col-12 field-col">
              <input-base
                v-model="checkPassword"
                type="password"
                id="checkPassword"
                label="payment.customer.confirm_password"
                :invalid="$v.checkPassword.$error"
                @change="$v.checkPassword.$touch()"
                @keyup="createPassword"
                :submit="true"
              />
              <span class="error">{{ validationMsg($v.checkPassword) }}</span>
            </div>
          </div>
          <div class="footer">
            <button class="btn btn-primary createWithPassword" @click="createPassword" type="button">{{ $t('payment.customer.save_password') }}</button>
            <button type="button" class="btn btn-secondary createWithoutPassword" @click="$emit('submit')">{{ $t('payment.customer.without_password') }}</button>
          </div>
        </form>
      </div>
    </div>
  </modal>
</template>

<script>
import { sync, call } from "vuex-pathify";
import { Modal, InputBase } from "@/components";
import { validationMixin } from "vuelidate";
import { required, sameAs } from "vuelidate/lib/validators";
import mixins from "@/mixins";

export default {
  name: "account-create",
  mixins: [mixins.globals, validationMixin, mixins.validate],
  components: { Modal, InputBase },
  data() {
    return {
      password: '',
      checkPassword: ''
    }
  },
  created() {
    this.createAccount = false;
  },
  methods: {
    submitPassword: call("customer/createAccount"),
    createPassword() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.submitPassword(this.password).then(() => {
          this.$emit('submit')
        })
      }
    }
  },
  computed: {
    createAccount: sync("modals/accountCreate")
  },
  validations: {
    password: {
      required,
      goodPassword:(password) => {
        return password.length >= 6 &&
        /[a-z]/.test(password) &&
        /[A-Z]/.test(password)
      }
    },
    checkPassword: {
      required,
      sameAsPassword: sameAs('password')
    }
  }
};
</script>